import styles from './styles/input-filter.module.css';

import {ReactComponent as SearchIcon} from '../../../assets/common/search.svg';

export default function InputFilter({ type, placeholder, name, value, handleChange }) {
    return (
        <div className={styles.wrapper} datatype={type}>
            <SearchIcon />
            <input placeholder={placeholder}
                   name={name}
                   value={value}
                   onChange={handleChange}
                   autoComplete='off'
            />
        </div>
    );
}
